import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  StarIcon as FiAward,
  CommandLineIcon as FiFunction,
  CodeBracketIcon as FiCode,
} from '@heroicons/react/24/outline';

const NS = 'modules.salaires.pages.parametresPage';

const ParametresPage = () => {
  const { t } = useTranslation();
  const p = (key, opts) => t(`${NS}.${key}`, opts);
  const [activeTab, setActiveTab] = useState('primes');

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold text-white mb-6">{p('title')}</h1>
      <p className="text-gray-300 mb-8">{p('subtitle')}</p>

      <div className="flex flex-wrap gap-2 mb-8">
        <button
          type="button"
          onClick={() => setActiveTab('primes')}
          className={`px-4 py-2 rounded-lg flex items-center gap-2 ${
            activeTab === 'primes'
              ? 'bg-teal-600 text-white'
              : 'bg-white/5 text-gray-300 hover:bg-white/10'
          }`}
        >
          <FiAward className="text-lg" />
          {p('tab_primes')}
        </button>

        <button
          type="button"
          onClick={() => setActiveTab('codes')}
          className={`px-4 py-2 rounded-lg flex items-center gap-2 ${
            activeTab === 'codes'
              ? 'bg-indigo-600 text-white'
              : 'bg-white/5 text-gray-300 hover:bg-white/10'
          }`}
        >
          <FiCode className="text-lg" />
          {p('tab_codes')}
        </button>

        <button
          type="button"
          onClick={() => setActiveTab('formules')}
          className={`px-4 py-2 rounded-lg flex items-center gap-2 ${
            activeTab === 'formules'
              ? 'bg-blue-600 text-white'
              : 'bg-white/5 text-gray-300 hover:bg-white/10'
          }`}
        >
          <FiFunction className="text-lg" />
          {p('tab_formulas')}
        </button>
      </div>

      {activeTab === 'primes' && (
        <div className="animate-fadeIn">
          <h2 className="text-xl font-semibold mb-4 text-white">{p('section_primes_title')}</h2>
        </div>
      )}

      {activeTab === 'codes' && (
        <div className="animate-fadeIn">
          <h2 className="text-xl font-semibold mb-4 text-white">{p('section_codes_title')}</h2>
        </div>
      )}

      {activeTab === 'formules' && (
        <div className="animate-fadeIn">
          <h2 className="text-xl font-semibold mb-4 text-white">{p('section_formulas_title')}</h2>
          <p className="text-gray-400">{p('section_formulas_desc')}</p>
        </div>
      )}
    </div>
  );
};

export default ParametresPage;
